export const LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST = 'LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST';
export const LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS = 'LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS';
export const LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE = 'LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/constants/lead_manage_leads_status.constants.js